import { PRICE_DROP_SUPPRESSION_EXPERIMENT } from '~/constants/common/priceDropSuppression';

export const clientSideBrowserCookieIdExperiments: Record<string, never> = {};

export const serverSideBrowserCookieIdExperiments = {
  'car-ancillaries-preload-spinner-data': {},
  [PRICE_DROP_SUPPRESSION_EXPERIMENT]: {},
  'car-merch-ui-vault-spinner': {},
  'car-merch-ui-vdp-jump-start-v2': {},
  'car-merch-ui-vdp-mini-hero': {},
  'car-merch-ui-vdp-miu-miu-standards-and-150-inspection': {},
  'car-merch-ui-vdp-spinner-exterior-and-interior-buttons': {}
};

export const clientSideUserIdExperiments = {};

// NOTE: Not currently wired up in the getExperiments middleware
export const serverSideUserIdExperiments = {};

export const clientSideExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments
};

export const serverSideExperiments = {
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const browserCookieIdExperiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...serverSideBrowserCookieIdExperiments
};

export const userIdExperiments = {
  ...clientSideUserIdExperiments,
  ...serverSideUserIdExperiments
};

export const experiments = {
  ...clientSideBrowserCookieIdExperiments,
  ...clientSideUserIdExperiments,
  ...serverSideBrowserCookieIdExperiments,
  ...serverSideUserIdExperiments
};

export const experimentNames = Object.keys(experiments);
